import React from 'react';
import { connect } from '@gasbuddy/react';
import _ from 'lodash';
import { FlexGrid, Header } from '@gasbuddy/react-components';
import { getHoursForDisplay, transformOpeningHours } from './helpers';
import DayOfTheWeek from './day-of-the-week';
import styles from './styles.css';
import BannerMessage from '../../banner-message';
import StationPropType from '../../../utils/prop-types/station';
import { HOURS_BEING_SAVED_MESSAGE } from '../../../../lib/constants/constants';

class ViewContent extends React.Component {
  static propTypes = {
    station: StationPropType,
  };

  static defaultProps = {
    station: null,
  };

  constructor(props) {
    super(props);

    const { regularHours } = transformOpeningHours(this.props.station.opening_hours);
    this.state = {
      regularHours,
    };
  }

  componentDidUpdate = (prevProps) => {
    const { station: { opening_hours: openingHours } } = this.props;

    if (!_.isEqual(openingHours, prevProps.station.opening_hours)) {
      const { regularHours } = transformOpeningHours(this.props.station.opening_hours);
      this.setState(() => ({ regularHours }));
    }
  }

  render = () => {
    const { regularHours, serverReturnedDifferentHours } = getHoursForDisplay(this.state.regularHours);

    if (!this.props.station.opening_hours.opening_hours) {
      return (<BannerMessage message="PLEASE UPDATE YOUR STATION HOURS" />);
    }

    return (
      <>
        {serverReturnedDifferentHours && <BannerMessage upperCase message={HOURS_BEING_SAVED_MESSAGE} />}
        <Header uppercase className={styles.stationHoursTitle} as="h3" size="sm">regular hours</Header>
        <FlexGrid className={styles.stationHoursBoxContainer}>
          {(regularHours || []).map(item => (
            <FlexGrid.Column key={item.day} mobile={6} tablet={1} className={styles.stationHoursSingleBox}>
              <DayOfTheWeek
                operationHours={item}
              />
            </FlexGrid.Column>
          ))}
        </FlexGrid>
      </>
    );
  }
}

const mapStateToProps = state => ({
  station: state.station,
});

export default connect(mapStateToProps)(ViewContent);
